import React, { useRef } from "react";
import styles from "./common.module.scss";
import { ChartView, Pagination as PaginationModel } from "src/types/experiences/leadsAndReports";

interface PaginationProps {
  pagination?: PaginationModel;
  type?: string;
  // eslint-disable-next-line no-unused-vars
  onClick: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({ pagination, type, onClick }) => {
  const current = pagination?.current ?? pagination?.currentPage ?? 0;
  const totalPages = pagination?.totalPages ?? 1;
  const total = pagination?.totalRecordsCount ?? 0;
  const perPage = 5;
  const from = total === 0 ? 0 : current * perPage + 1;
  const to = Math.min((current + 1) * perPage, total);

  return (
    <div className={styles.pagination}>
      <button disabled={current <= 0} onClick={() => onClick(current - 1)}>
        <i className={`paperflite-dropdown ${styles.chevronLeft}`} />
      </button>
      <span>
        {from} - {to} of {total} {type}
      </span>
      <button disabled={current >= totalPages - 1} onClick={() => onClick(current + 1)}>
        <i className={`paperflite-dropdown ${styles.chevronRight}`} />
      </button>
    </div>
  );
};

interface TableFooterProps {
  pagination?: PaginationModel;
  currentChart: ChartView;
  // eslint-disable-next-line no-unused-vars
  handlePageChange: (page: number) => void;
  paginationName?: string;
}

export const TableFooter: React.FC<TableFooterProps> = ({
  pagination,
  currentChart,
  handlePageChange,
  paginationName,
}) => {
  const lastPagination = useRef<PaginationModel | undefined>(undefined);
  if (pagination !== undefined) lastPagination.current = pagination;
  const stable = pagination ?? lastPagination.current;

  if (!stable || currentChart !== "table_view") return null;
  const totalPages = stable.totalPages ?? 1;
  if (totalPages <= 1) return null;
  return (
    <div className={styles.tableFooter}>
      <Pagination pagination={stable} type={paginationName} onClick={handlePageChange} />
    </div>
  );
};
